import React from "react";
import { useMenu } from "../../context/MenuContext";
import { getModuleName } from "../../utils/commonHelper";
import BackdropProgressBar from "../ui/BackdropProgressBar";
import {
  ExcludeSideNavModuleSet,
  ModuleNames,
  WORKFLOW_STATIC_UI_BYPASS,
} from "../../data/constants";
import NotAuthorized from "../../pages/error/NotAuthorized";

const MenuGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { menu, permissions, loading } = useMenu();
  const moduleName = getModuleName()?.toLowerCase();

  if (loading) return <BackdropProgressBar loading={loading} />;
  if (
    WORKFLOW_STATIC_UI_BYPASS &&
    moduleName === ModuleNames.WorkflowLibrary.toLowerCase()
  ) {
    return <>{children}</>;
  }
  if (menu.length === 0) {
    return <NotAuthorized isAccessMenu={false} />;
  }

  const allUrls = menu.flatMap(section =>
    section.listItems.map(item => item.moduleName?.toLowerCase())
  );

  if (moduleName === ModuleNames.Messages.toLowerCase()) {
    const isMessageEnable = permissions?.find(permission =>
      permission.moduleName === ModuleNames.Messages)?.canView;
    if (!isMessageEnable) {
      return <NotAuthorized  isAccessMenu={true}/>;
    }
  }

  // The PostIF form is opened by URL - from the start screen, a resumed draft, or a
  // returned-for-changes link - and is deliberately NOT a side-nav entry, so the
  // menu-membership check below would reject it for every user. Gate it on its own CanEdit
  // instead: Epic 79767 AC5 keeps the Form permission separate from PostIF-MyForms and
  // PostIF-List so a role can fill a form without being able to see either list.
  if (moduleName === ModuleNames.PostIFForm.toLowerCase()) {
    const canEditForm = permissions?.find(
      permission => permission.moduleName === ModuleNames.PostIFForm)?.canEdit;
    return canEditForm ? <>{children}</> : <NotAuthorized isAccessMenu={true} />;
  }

  if (!allUrls.includes(moduleName) && !ExcludeSideNavModuleSet.has(moduleName)) {
    return <NotAuthorized isAccessMenu={true}/>;
  }

  return <>{children}</>;
};

export default MenuGuard;
